/* src/app/shared/controls/tab-control/tab-page.component.scss */
.tab-page {
  width: 100%;
}
/*# sourceMappingURL=tab-page.component-I4UWFE6S.css.map */
